
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c60c30","d":"M0 0h42v28H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 12h14V0h4v12h24v4H18v12h-4V16H0z"}})])
          )
        }
      }
    